import { jsx as _jsx } from "react/jsx-runtime";
import { MoreHoriz } from "sprout-ui-icons";
import { forwardRef } from "react";
import { useMergeRefs } from "sprout-hooks";
import { Button } from "sprout-ui-dom/dist/Button";
import { PopoverTrigger, PopoverReference } from "sprout-ui-dom/dist/Popover";
const MenuTrigger = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children , icon =/*#__PURE__*/ _jsx(MoreHoriz, {}) , onOpenToggle , setReferenceElement , setTriggerElement ,  } = props;
    const mergedSetReferenceElement = useMergeRefs(setReferenceElement, ref);
    return /*#__PURE__*/ _jsx(PopoverReference, {
        setReferenceElement: mergedSetReferenceElement,
        children: /*#__PURE__*/ _jsx(PopoverTrigger, {
            onOpenToggle: onOpenToggle,
            setTriggerElement: setTriggerElement,
            children: children || /*#__PURE__*/ _jsx(Button, {
                variant: "circle",
                children: icon
            })
        })
    });
});
export default MenuTrigger;
